import request from '../../request';

export const getUserList = (params: any) => request.post('/rental/scm/user/listByPage', params);

export const createUser = (params: any) => request.post('/rental/scm/user/create', params);

export const changeStatus = (params: any) => request.post('/rental/scm/user/changeStatus', params);

export const getAllRole = (params: any) => request.post('/rental/scm/role/listWithoutUsers', params);

export const getAllStore = () => request.get('/rental/scm/user/storeList');

export const editUser = (params: any) => request.post('/rental/scm/user/update', params);

export const bindStore = (params: any) => request.post('/rental/scm/user/bindStore', params);

export const getRoleList = (params: any) => request.post('/rental/scm/role/listWithUsers', params);

export const getRoleFeatures = (params: any) => request.post('/rental/scm/role/getRoleFeatures', params);

export const getAllUsers = (params?: any) => request.get('/rental/scm/user/allUser', params);

export const bindUsers = (params?: any) => request.post('/rental/scm/role/bindUsers', params);

export const deleteUser = (params?: any) => request.post('/rental/scm/user/delete', params);
